import { render, staticRenderFns } from "./dynamic_effects.vue?vue&type=template&id=c91c7a9c&scoped=true"
import script from "./dynamic_effects.vue?vue&type=script&lang=js"
export * from "./dynamic_effects.vue?vue&type=script&lang=js"
import style0 from "./dynamic_effects.vue?vue&type=style&index=0&id=c91c7a9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e55c6b833ee07bd5ead5f0ade73438ed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91c7a9c",
  null
  
)

export default component.exports